<template>
  <!-- Lead-capture popup behind every "Richiedi un contatto" agency CTA (home
       "Sei un'agenzia?" band and the /agenzie page). -->
  <base-popup
    :show="show"
    title="Richiedi un contatto commerciale"
    card-class="ic-home-agencies__popup"
    close-test-id="agency-contact-close"
    scrollable
    @close="$emit('close')"
  >
    <p v-if="submitted" data-testid="agency-success" class="ic-home-agencies__success">
      Grazie! Abbiamo ricevuto la tua richiesta: ti contatteremo al più presto.
    </p>
    <agency-contact-form v-else @submit="onSubmit" />
  </base-popup>
</template>

<script>
import { functions } from '@/firebase/init.js';
import { httpsCallable } from 'firebase/functions';
import BasePopup from '@/components/BasePopup.vue';
import AgencyContactForm from '@/components/forms/AgencyContactForm.vue';
import { sendAgencyContactEmails } from '@/services/agencyContact';

export default {
  name: 'AgencyContactPopup',
  components: { BasePopup, AgencyContactForm },
  props: {
    show: { type: Boolean, default: false },
    // Where the form lives, reported in the internal email ('home' | 'agenzie').
    source: { type: String, default: 'home' },
  },
  emits: ['close'],
  data() {
    return { submitted: false };
  },
  methods: {
    async onSubmit(payload) {
      // Thank the user immediately; the emails are best-effort (same philosophy as
      // the videocall flow). We notify the immaginacasa commercial inbox and send
      // the agent a confirmation, both via the shared Mailjet "madre" template.
      this.submitted = true;
      try {
        const call = httpsCallable(functions, 'sendNotificationEmail');
        await sendAgencyContactEmails({ sendEmail: (p) => call(p), ...payload, source: this.source });
      } catch (e) {
        // Non-blocking: the UI already confirmed. Log for observability.
        console.error('Agency contact email failed', e);
      }
    },
  },
};
</script>
